// AUTO-GENERATED by curriculum-gen/src/gen_lexrich5_district.py — do not edit by hand.
// Lexington-Richland 5: Benchmark Advance-aligned lessons + 2,500-user social proof.
import { CurriculumDistrict, CurriculumLesson } from './peninsula-district';

export type { CurriculumLesson };

export const LEXRICH5_DISTRICT: CurriculumDistrict = {
  "slug": "lexrich5",
  "name": "Lexington-Richland School District Five",
  "state": "SC",
  "location": "Irmo · Chapin · Ballentine — Lexington & Richland Counties, South Carolina, USA",
  "framework": "South Carolina College- and Career-Ready ELA Standards",
  "gradeRange": "K–5",
  "socialProof": "2,500+ Lexington-Richland 5 educators and students have already used Pressto",
  "lessonCount": 50,
  "programs": [
    "Benchmark Advance"
  ],
  "lessons": [
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 10: Exploring Sound",
      "title": "How We Make and Hear Sound",
      "prompt": "Sounds are all around us, made when things move back and forth.\n\nWrite to teach your reader how sounds are made and how we hear them.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "sound",
        "hear",
        "ear",
        "loud",
        "soft",
        "vibrate",
        "music",
        "noise",
        "high",
        "low"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 1: Living Things Grow & Change",
      "title": "How a Living Thing Grows",
      "prompt": "Every living thing grows and changes during its life.\n\nChoose a plant or animal you studied. Write to teach your reader how it grows and changes.\n\nUse facts from your reading.",
      "plan": "sequence",
      "purpose": "Aligned Writing",
      "importantWords": [
        "living",
        "grow",
        "change",
        "plant",
        "animal",
        "seed",
        "young",
        "adult",
        "life",
        "stage"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 2: Animals & Their Stories",
      "title": "All About an Animal",
      "prompt": "Animals come in all shapes and sizes, and each one is special.\n\nChoose an animal you learned about. Write to teach your reader about it — what it looks like, where it lives, and what it eats.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "animal",
        "habitat",
        "food",
        "body",
        "live",
        "move",
        "special",
        "wild",
        "fur",
        "wings"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 3: Being Part of a Community",
      "title": "How We Stay Safe Together",
      "prompt": "People in a community follow rules and help each other stay safe.\n\nWrite to explain one way people stay safe in your community, and why it is important.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "community",
        "safe",
        "rule",
        "help",
        "people",
        "neighbor",
        "share",
        "together",
        "kind",
        "care"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 4: Characters in Stories",
      "title": "My Favorite Character",
      "prompt": "Stories are full of interesting characters who do all kinds of things.\n\nChoose your favorite character from a story. Write to describe what they are like and why you like them.\n\nUse details from the story.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "character",
        "story",
        "favorite",
        "brave",
        "kind",
        "funny",
        "feeling",
        "do",
        "like",
        "describe"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 5: Technology Helps Us",
      "title": "A Machine That Helps People",
      "prompt": "Machines and technology help people do work and solve problems.\n\nChoose a machine or tool you know about. Write to teach your reader what it does and how it helps people.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "machine",
        "technology",
        "tool",
        "help",
        "work",
        "robot",
        "computer",
        "build",
        "fix",
        "useful"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 6: Stories Teach Us",
      "title": "The Problem in a Story",
      "prompt": "In many stories, a character has a problem they need to solve.\n\nChoose a story you read. Write to tell your reader about the problem and how it gets solved.\n\nUse details from the story.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "story",
        "problem",
        "solve",
        "character",
        "help",
        "try",
        "solution",
        "end",
        "lesson",
        "happen"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 7: Past, Present & Future",
      "title": "Long Ago and Today",
      "prompt": "Life long ago was different from life today in many ways.\n\nWrite to explain one way life in the past was different from life now.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "past",
        "present",
        "long ago",
        "today",
        "change",
        "different",
        "history",
        "old",
        "new",
        "time"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 8: Observing the Sky",
      "title": "What I See in the Sky",
      "prompt": "When we look up, we can see the sun, the moon, and the stars.\n\nChoose something you see in the sky — the sun, the moon, or the stars. Write to teach your reader about it.\n\nUse facts from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "sky",
        "sun",
        "moon",
        "star",
        "day",
        "night",
        "light",
        "space",
        "shine",
        "observe"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "1st",
      "theme": "Grade 1 Benchmark Advance · Unit 9: Goods & Services",
      "title": "Things We Buy and Use",
      "prompt": "People make and sell goods, and they do jobs called services to help others.\n\nWrite to explain the difference between a good and a service, and give an example of each.\n\nUse facts from your reading.",
      "plan": "compare-contrast",
      "purpose": "Aligned Writing",
      "importantWords": [
        "goods",
        "services",
        "buy",
        "sell",
        "job",
        "money",
        "make",
        "help",
        "need",
        "store"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 10: States of Matter",
      "title": "Solids, Liquids, and Gases",
      "prompt": "Everything around us is made of matter, and matter comes in different states.\n\nWrite to explain the three states of matter — solid, liquid, and gas — and give an example of each.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "matter",
        "solid",
        "liquid",
        "gas",
        "state",
        "shape",
        "change",
        "melt",
        "freeze",
        "describe"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 1: Plant & Animal Survival",
      "title": "How Living Things Survive",
      "prompt": "Plants and animals have special features that help them survive in the world around them.\n\nChoose a plant or animal you studied. Write to teach your reader how it survives — what it needs and how its body or parts help it live.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "survive",
        "plant",
        "animal",
        "habitat",
        "adapt",
        "grow",
        "needs",
        "protect",
        "environment",
        "living"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 2: Stories & Story Elements",
      "title": "A Character Who Faces a Challenge",
      "prompt": "In many stories, a character faces a challenge and has to find a way through it.\n\nChoose a story you read. Write to describe the character, the challenge they face, and how they handle it.\n\nUse details from the story to support your ideas.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "character",
        "challenge",
        "story",
        "problem",
        "solve",
        "feeling",
        "decide",
        "setting",
        "event",
        "lesson"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 3: Government & Community Services",
      "title": "How Our Community Helps Us",
      "prompt": "Our government and community workers provide services that keep people safe and healthy.\n\nChoose one community service — like firefighters, libraries, or trash collection. Write to explain what it does and why it matters.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "government",
        "community",
        "service",
        "citizen",
        "help",
        "safe",
        "worker",
        "public",
        "rules",
        "leader"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 4: Folktales",
      "title": "The Lesson in a Folktale",
      "prompt": "Folktales are stories passed down for generations, and they often teach a lesson.\n\nChoose a folktale you read. Write to retell what happens and explain the lesson it teaches.\n\nUse details from the folktale to support your retelling.",
      "plan": "retell-the-narrative",
      "purpose": "Aligned Writing",
      "importantWords": [
        "folktale",
        "lesson",
        "character",
        "tradition",
        "story",
        "wise",
        "clever",
        "moral",
        "culture",
        "retell"
      ],
      "standards": [
        "Narrative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 5: Inventions & Solving Problems",
      "title": "An Invention That Solves a Problem",
      "prompt": "Inventors create new things to solve everyday problems.\n\nChoose an invention you learned about, or imagine one of your own. Write to explain the problem it solves and how it works.\n\nUse clear details so your reader understands.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "invention",
        "inventor",
        "problem",
        "solve",
        "idea",
        "create",
        "tool",
        "design",
        "useful",
        "improve"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 6: Tales Across Cultures",
      "title": "A Tale From Another Culture",
      "prompt": "People all around the world tell tales that share their culture and beliefs.\n\nChoose a tale you read from another culture. Write to retell it and explain what it shows about the people who tell it.\n\nUse details from the tale to support your ideas.",
      "plan": "retell-the-narrative",
      "purpose": "Aligned Writing",
      "importantWords": [
        "tale",
        "culture",
        "tradition",
        "story",
        "belief",
        "people",
        "world",
        "storyteller",
        "lesson",
        "share"
      ],
      "standards": [
        "Narrative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 7: History & Primary Sources",
      "title": "Learning From the Past",
      "prompt": "Historians learn about the past from primary sources — real artifacts, letters, and photographs left behind.\n\nChoose something you learned about the past. Write to explain what happened and how we know about it.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "history",
        "past",
        "primary source",
        "artifact",
        "evidence",
        "long ago",
        "record",
        "discover",
        "photograph",
        "learn"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 8: Wind & Water Change the Land",
      "title": "How Wind and Water Shape the Land",
      "prompt": "Over time, wind and water slowly change the shape of the land around us.\n\nWrite to explain how wind or water can change the land — what they do and what they leave behind.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "wind",
        "water",
        "land",
        "erosion",
        "change",
        "shape",
        "rock",
        "river",
        "weather",
        "slow"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "2nd",
      "theme": "Grade 2 Benchmark Advance · Unit 9: Goods, Services & Money",
      "title": "Goods, Services, and How We Trade",
      "prompt": "People make goods and provide services, and they trade money to get what they need.\n\nWrite to explain the difference between goods and services, and how people use money to get them.\n\nUse facts and details from your reading.",
      "plan": "compare-contrast",
      "purpose": "Aligned Writing",
      "importantWords": [
        "goods",
        "services",
        "money",
        "trade",
        "buy",
        "sell",
        "produce",
        "need",
        "want",
        "market"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 10: Forces & Motion",
      "title": "How Forces Make Things Move",
      "prompt": "A force is a push or a pull that can make objects move, stop, or change direction.\n\nWrite an informative piece that explains how forces make objects move, using examples you learned about.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "force",
        "push",
        "pull",
        "motion",
        "move",
        "gravity",
        "friction",
        "speed",
        "direction",
        "object"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 1: Animal Adaptations",
      "title": "How Animals Adapt to Survive",
      "prompt": "Over time, animals develop special features and behaviors that help them survive where they live.\n\nChoose an animal you studied. Write an informative piece that explains how its adaptations help it find food, stay safe, and survive in its habitat.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "adapt",
        "adaptation",
        "survive",
        "habitat",
        "feature",
        "behavior",
        "camouflage",
        "predator",
        "environment",
        "trait"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 2: Storytelling & Character Actions",
      "title": "What a Character's Actions Reveal",
      "prompt": "Writers show what characters are like through the things they say and do.\n\nChoose a character from a story you read. Write to explain what their actions reveal about who they are.\n\nUse details and examples from the story to support your ideas.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "character",
        "action",
        "trait",
        "motivation",
        "decision",
        "reveal",
        "story",
        "respond",
        "feeling",
        "describe"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 3: Civic Participation",
      "title": "How Citizens Make a Difference",
      "prompt": "People take part in their communities in many ways — voting, volunteering, and following rules that keep everyone safe.\n\nWrite an informative piece that explains one way citizens participate in their community and why it matters.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "citizen",
        "community",
        "vote",
        "volunteer",
        "rule",
        "responsibility",
        "government",
        "rights",
        "participate",
        "civic"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 4: Character & Narrator",
      "title": "Seeing a Story Through the Narrator",
      "prompt": "The narrator is the voice that tells a story, and it shapes what we know about the characters.\n\nChoose a story you read. Write to describe a main character and explain how the narrator helps you understand them.\n\nUse details from the story to support your ideas.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "narrator",
        "character",
        "point of view",
        "story",
        "describe",
        "perspective",
        "feeling",
        "reveal",
        "voice",
        "detail"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 5: Inventions & Communication",
      "title": "An Invention That Changed How We Communicate",
      "prompt": "Inventions like the telephone and the internet changed the way people share ideas and stay connected.\n\nChoose an invention you learned about. Write an informative piece that explains how it changed the way people communicate.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "invention",
        "communicate",
        "technology",
        "connect",
        "message",
        "idea",
        "change",
        "share",
        "inventor",
        "improve"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 6: Realistic Fiction & Choices",
      "title": "A Character Who Makes a Hard Choice",
      "prompt": "In realistic fiction, characters face the same kinds of choices and challenges that real people do.\n\nChoose a character from a story you read who makes a hard choice. Write to explain the choice they make and what happens because of it.\n\nUse details from the story to support your ideas.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "choice",
        "character",
        "realistic",
        "challenge",
        "decide",
        "consequence",
        "problem",
        "solve",
        "feeling",
        "outcome"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 7: Communities Around the World",
      "title": "What Makes a Community Special",
      "prompt": "Communities around the world have their own people, places, and ways of life.\n\nChoose a community you studied. Write an informative piece that describes what makes it special — its people, its place, and its traditions.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "community",
        "culture",
        "tradition",
        "people",
        "place",
        "neighborhood",
        "custom",
        "share",
        "region",
        "describe"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 8: Weather & Climate",
      "title": "Weather, Climate, and How They Work",
      "prompt": "Weather is what is happening in the sky right now, while climate is the usual weather of a place over time.\n\nWrite an informative piece that explains the difference between weather and climate, and how weather works.\n\nUse facts and details from your reading.",
      "plan": "compare-contrast",
      "purpose": "Aligned Writing",
      "importantWords": [
        "weather",
        "climate",
        "temperature",
        "season",
        "predict",
        "pattern",
        "storm",
        "rain",
        "forecast",
        "change"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "3rd",
      "theme": "Grade 3 Benchmark Advance · Unit 9: Economics & Choices",
      "title": "Making Smart Economic Choices",
      "prompt": "People cannot have everything they want, so they make economic choices about how to use their money.\n\nWrite an informative piece that explains an economic choice people make and why they have to choose.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "economy",
        "choice",
        "money",
        "needs",
        "wants",
        "cost",
        "save",
        "spend",
        "trade",
        "decide"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 10: The Power of Electricity",
      "title": "How Electricity Powers Our World",
      "prompt": "Electricity powers almost everything in our daily lives, from lights to phones.\n\nWrite an informative piece that explains what electricity is, how it travels, and how we use it.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "electricity",
        "energy",
        "power",
        "circuit",
        "current",
        "wire",
        "charge",
        "conductor",
        "battery",
        "flow"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 1: Observing Nature",
      "title": "What I Observed in Nature",
      "prompt": "Writers and scientists pay close attention to the natural world, noticing details others miss.\n\nChoose something in nature you have observed or studied. Write an informative piece that describes it in detail — what it looks like, how it behaves, and what makes it interesting.\n\nUse precise details so your reader can picture it.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "nature",
        "observe",
        "detail",
        "describe",
        "natural",
        "notice",
        "pattern",
        "living",
        "environment",
        "wonder"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 2: Characters' Actions and Reactions",
      "title": "How a Character's Reactions Drive the Story",
      "prompt": "In a good story, what characters do — and how they react to events — moves the plot forward.\n\nChoose a story you read. Write to explain how a character's actions and reactions shape what happens and reveal who they are.\n\nUse evidence from the text to support your explanation.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "character",
        "action",
        "reaction",
        "plot",
        "motivation",
        "event",
        "respond",
        "trait",
        "consequence",
        "develop"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 3: Government in Action",
      "title": "How Government Solves Problems",
      "prompt": "Governments at the local, state, and national levels provide services and solve problems for the people they serve.\n\nChoose one way government takes action — a service it provides or a problem it solves. Write an informative piece that explains how it works and why it matters.\n\nUse facts and details from your reading.",
      "plan": "problem-solution",
      "purpose": "Aligned Writing",
      "importantWords": [
        "government",
        "service",
        "citizen",
        "law",
        "elect",
        "official",
        "community",
        "solve",
        "responsibility",
        "public"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 4: Understanding Different Points of View",
      "title": "The Same Event, Different Points of View",
      "prompt": "The same event can look very different depending on whose point of view we hear.\n\nChoose an event from a story or from history. Write to explain how two different people might see it differently and what that reveals.\n\nUse evidence from your reading to support your ideas.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "point of view",
        "perspective",
        "narrator",
        "opinion",
        "bias",
        "interpret",
        "event",
        "differ",
        "reveal",
        "compare"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 5: Technology for Tomorrow",
      "title": "A Technology That Could Shape the Future",
      "prompt": "New technologies have the power to change how we live, work, and solve problems.\n\nChoose a technology — real or one you imagine. Write an informative piece that explains what it does and how it could improve life in the future.\n\nUse clear details so your reader understands how it works.",
      "plan": "problem-solution",
      "purpose": "Aligned Writing",
      "importantWords": [
        "technology",
        "future",
        "invention",
        "innovate",
        "improve",
        "design",
        "solve",
        "device",
        "impact",
        "change"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 6: Confronting Challenges",
      "title": "A Character Who Confronts a Challenge",
      "prompt": "Stories often show characters facing tough challenges and finding the strength to overcome them.\n\nChoose a character from a story you read who confronts a challenge. Write to explain the challenge and how facing it changes the character.\n\nUse evidence from the text to support your explanation.",
      "plan": "problem-solution",
      "purpose": "Aligned Writing",
      "importantWords": [
        "challenge",
        "confront",
        "overcome",
        "courage",
        "obstacle",
        "character",
        "grow",
        "perseverance",
        "change",
        "struggle"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 7: The Transcontinental Railroad",
      "title": "The Railroad That Connected a Nation",
      "prompt": "The Transcontinental Railroad linked the eastern and western United States for the first time.\n\nWrite an informative piece that explains what the Transcontinental Railroad was, how it was built, and why it changed the country.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "railroad",
        "transcontinental",
        "connect",
        "build",
        "worker",
        "track",
        "west",
        "travel",
        "nation",
        "history"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 8: Earth Changes",
      "title": "How Earth's Surface Changes",
      "prompt": "Earth's surface is always changing — sometimes slowly, and sometimes in a sudden, powerful event.\n\nWrite an informative piece that explains how Earth's surface changes, using examples of both slow and fast changes.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "Earth",
        "surface",
        "erosion",
        "earthquake",
        "volcano",
        "weathering",
        "change",
        "landform",
        "slow",
        "sudden"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "4th",
      "theme": "Grade 4 Benchmark Advance · Unit 9: Resources and Their Impact",
      "title": "How We Use Natural Resources",
      "prompt": "People depend on natural resources — like water, trees, and minerals — but using them affects the world around us.\n\nChoose a natural resource. Write an informative piece that explains how people use it and the impact that use has on the environment.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "resource",
        "natural",
        "environment",
        "impact",
        "energy",
        "conserve",
        "renewable",
        "use",
        "supply",
        "protect"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 10: Transforming Matter",
      "title": "How Matter Transforms",
      "prompt": "Matter can change in different ways — sometimes its shape, and sometimes into something entirely new.\n\nWrite an informative essay that explains how matter can change, describing the difference between physical and chemical changes.\n\nUse facts and details from your reading.",
      "plan": "compare-contrast",
      "purpose": "Aligned Writing",
      "importantWords": [
        "matter",
        "transform",
        "physical",
        "chemical",
        "change",
        "state",
        "reaction",
        "substance",
        "property",
        "mixture"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 1: Cultivating Natural Resources",
      "title": "Using Natural Resources Wisely",
      "prompt": "People depend on natural resources like soil, water, and forests — and how we manage them shapes the future.\n\nChoose a natural resource. Write an informative essay that explains how people use it and how it can be used wisely so it lasts.\n\nUse facts and details from your reading, and include linking words to connect your ideas.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "resource",
        "natural",
        "cultivate",
        "conserve",
        "renewable",
        "sustain",
        "soil",
        "harvest",
        "manage",
        "supply"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 2: Developing Characters' Relationships",
      "title": "How a Relationship Changes in a Story",
      "prompt": "In a well-written story, the relationships between characters grow and change as events unfold.\n\nChoose a story you read. Write to explain how the relationship between two characters develops, and what causes it to change.\n\nUse evidence from the text to support your explanation.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "relationship",
        "character",
        "develop",
        "change",
        "conflict",
        "trust",
        "bond",
        "interact",
        "respond",
        "reveal"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 3: The U.S. Constitution: Then and Now",
      "title": "Why the Constitution Still Matters",
      "prompt": "The U.S. Constitution was written long ago, but its ideas still shape our country today.\n\nChoose one idea or principle from the Constitution. Write an informative essay that explains what it means and why it still matters now.\n\nUse facts and details from your reading.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "Constitution",
        "government",
        "rights",
        "amendment",
        "freedom",
        "branch",
        "law",
        "citizen",
        "principle",
        "founders"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 4: Recognizing Author's Point of View",
      "title": "An Author's Point of View",
      "prompt": "Authors write with a purpose, and their point of view shapes how they present a topic.\n\nChoose a text you read. Write to explain the author's point of view on the topic and how you can tell what they think.\n\nUse evidence from the text to support your explanation.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "point of view",
        "author",
        "purpose",
        "opinion",
        "evidence",
        "bias",
        "claim",
        "perspective",
        "persuade",
        "tone"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 5: Technology's Impact on Society",
      "title": "How a Technology Changed Society",
      "prompt": "New technologies do not just change tools — they change the way whole societies live and work.\n\nChoose a technology. Write an informative essay that explains how it has changed the way people live, work, or connect.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "technology",
        "society",
        "impact",
        "change",
        "communicate",
        "innovation",
        "progress",
        "effect",
        "connect",
        "transform"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 6: Up Against the Wild",
      "title": "Surviving Against the Wild",
      "prompt": "In survival stories, characters are pushed to their limits when they face the power of nature.\n\nChoose a survival story you read. Write to explain the challenge the character faces in the wild and how they survive.\n\nUse evidence from the text to support your explanation.",
      "plan": "description",
      "purpose": "Aligned Writing",
      "importantWords": [
        "survival",
        "wild",
        "nature",
        "challenge",
        "danger",
        "resourceful",
        "endure",
        "courage",
        "instinct",
        "overcome"
      ],
      "standards": [
        "Writing About Reading"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 7: Conflicts That Shaped a Nation",
      "title": "A Conflict That Shaped Our Nation",
      "prompt": "Throughout history, conflicts have changed the course of the United States.\n\nChoose a conflict you studied. Write an informative essay that explains what the conflict was about and how it shaped the nation.\n\nUse facts and details from your reading.",
      "plan": "cause-effect",
      "purpose": "Aligned Writing",
      "importantWords": [
        "conflict",
        "nation",
        "history",
        "cause",
        "effect",
        "war",
        "change",
        "leader",
        "freedom",
        "shape"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 8: Water: Fact and Fiction",
      "title": "The Science of Water",
      "prompt": "Water is essential to life, and the way it moves through our world is a fascinating real science.\n\nWrite an informative essay that explains something true about water — how the water cycle works, or how water shapes the Earth.\n\nUse facts and details from your reading.",
      "plan": "sequence",
      "purpose": "Aligned Writing",
      "importantWords": [
        "water",
        "cycle",
        "evaporate",
        "condense",
        "precipitation",
        "ocean",
        "freshwater",
        "vapor",
        "flow",
        "essential"
      ],
      "standards": [
        "Informative Writing"
      ]
    },
    {
      "program": "Benchmark Advance",
      "grade": "5th",
      "theme": "Grade 5 Benchmark Advance · Unit 9: The Economic Development of Cities",
      "title": "How Cities Grow and Thrive",
      "prompt": "Cities grow when people, jobs, trade, and resources come together in one place.\n\nWrite an informative essay that explains how a city develops economically — what helps it grow and why people move there.\n\nUse facts and details from your reading.",
      "plan": "sequence",
      "purpose": "Aligned Writing",
      "importantWords": [
        "city",
        "economy",
        "develop",
        "trade",
        "industry",
        "jobs",
        "population",
        "resource",
        "transport",
        "grow"
      ],
      "standards": [
        "Informative Writing"
      ]
    }
  ]
};
